/**
 * Generates an uuid
 * @see {@link https://www.w3resource.com/javascript-exercises/javascript-math-exercise-23.php}
 * @returns {String} a valid uuid
 */
export default function() {
  let dt = new Date().getTime();
  /* eslint-disable */
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (dt + Math.random() * 16) % 16 | 0;
    dt = Math.floor(dt / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  /* eslint-enable */
  return uuid;
}
